export default "__VITE_ASSET__uk9AC2C7__"